import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { IBAN_COMPONENT_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds.ts';
import { CURRENCY_OPTIONS } from '@dealstack/shared/lib/format/currency/currency.ts';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Select } from 'react-hook-form-mantine';
import { useBankAccountFormContext } from '../../BankAccountFormContext.tsx';
import { BANK_ACCOUNT_FORM_FIELDS, BankAccountFormValues } from '../../types.ts';

export const CurrencyField = () => {
	const tCapManage = useTranslationCapManage();
	const { control } = useFormContext<BankAccountFormValues>();
	const { fieldsDisabled } = useBankAccountFormContext();

	return (
		<Select
			control={control}
			name={BANK_ACCOUNT_FORM_FIELDS.currency}
			label={tCapManage('bank_account.drawer.currency.label')}
			placeholder={tCapManage('bank_account.drawer.currency.placeholder')}
			size="md"
			withAsterisk
			data={CURRENCY_OPTIONS}
			searchable
			disabled={fieldsDisabled}
			data-testid={IBAN_COMPONENT_ELEMENT_ID.BANK_CURRENCY_INPUT}
			allowDeselect
		/>
	);
};
